module.exports = __webpack_public_path__ + "img/img-dashboard.cc42f83d.png";